import { client } from '../../../../../common-utils/libraries/axios/axios';
import { POS_TERMINALS } from '../apiUrls';

const mutationMultiplePosBlocking = (onSuccess, onError) => {
    return {
        mutationFn: (blockingPayload) => {
            return client.post(POS_TERMINALS.BLACKLIST_MULTI.url, blockingPayload);
        },
        // onError: (error, variables, context)
        onError: (error) => {
            onError(error);
        },
        // onSuccess: (data, variables, context)
        onSuccess: () => {
            onSuccess();
        },
        // onSettled: (data, error, variables, context)
        onSettled: () => {
            // Error or success... doesn't matter!
        }
    };
};

export default mutationMultiplePosBlocking;